import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";

const NewMenuForm = () => {
  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");

  const [title, setTitle] = useState("");
  const [position, setPosition] = useState(0);
  const [isCategory, setIsCategory] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  // Fetch Menus
  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter(menu => menu.parent_id === null));
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  // Handle dropdown changes
  const handleMainCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedMainCategory(selectedId);
    setSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubCategory("");
    setSubSubCategories([]);
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
  };

  const handleSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubCategory(selectedId);
    setSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
  };

  const handleSubSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubCategory(selectedId);
    setSubSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
  };

  const handleSubSubSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubSubCategory(selectedId);
    setFinalCategories(menus.filter(menu => menu.parent_id === selectedId));
    setSelectedFinalCategory("");
  };

  const handleFinalCategoryChange = (e) => {
    setSelectedFinalCategory(parseInt(e.target.value));
  };

  // Handle Image Upload
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("parent_id", selectedFinalCategory || selectedSubSubSubCategory || selectedSubSubCategory || selectedSubCategory || selectedMainCategory || null);
      formData.append("position", parseInt(position));
      formData.append("is_category", isCategory);
      if (image) formData.append("image", image);

      console.log("Sending Form Data:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await axios.post(`${baseurl}addMenuWithImage`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Server Response:", response.data);

      // Refresh Menus
      axios.get(`${baseurl}getMenus`).then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter(menu => menu.parent_id === null));
      });

      // Reset Form
      setTitle("");
      setSelectedMainCategory("");
      setSelectedSubCategory("");
      setSelectedSubSubCategory("");
      setSelectedSubSubSubCategory("");
      setSelectedFinalCategory("");
      setPosition(0);
      setIsCategory(false);
      setImage(null);
      setPreview(null);
    } catch (error) {
      console.error("Error adding menu:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="row g-3 text-start">
      {/* Title */}
      <div className="col-md-12">
        <label className="form-label">Menu Title</label>
        <input type="text" className="form-control" placeholder="Eg. Business & Industrial" value={title} onChange={(e) => setTitle(e.target.value)} required />
      </div>

      {/* Main Category */}
      <div className="col-md-12">
        <label className="form-label">Main Category</label>
        <select className="form-select" value={selectedMainCategory} onChange={handleMainCategoryChange}>
          <option value="">Select Main Category</option>
          {mainCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
        </select>
      </div>

      {/* Sub Category */}
      {subCategories.length > 0 && (
        <div className="col-md-12">
          <label className="form-label">Sub Category</label>
          <select className="form-select" value={selectedSubCategory} onChange={handleSubCategoryChange}>
            <option value="">Select Sub Category</option>
            {subCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      {/* Sub-Sub Category */}
      {subSubCategories.length > 0 && (
        <div className="col-md-12">
          <label className="form-label">Sub-Sub Category</label>
          <select className="form-select" value={selectedSubSubCategory} onChange={handleSubSubCategoryChange}>
            <option value="">Select Sub-Sub Category</option>
            {subSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      {/* Sub-Sub-Sub Category */}
      {subSubSubCategories.length > 0 && (
        <div className="col-md-12">
          <label className="form-label">Sub-Sub-Sub Category</label>
          <select className="form-select" value={selectedSubSubSubCategory} onChange={handleSubSubSubCategoryChange}>
            <option value="">Select Sub-Sub-Sub Category</option>
            {subSubSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      {/* Final Category */}
      {finalCategories.length > 0 && (
        <div className="col-md-12">
          <label className="form-label">Final Category</label>
          <select className="form-select" value={selectedFinalCategory} onChange={handleFinalCategoryChange}>
            <option value="">Select Final Category</option>
            {finalCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      <div className="col-12 text-end">
        <button type="submit" className="btn submitbtnn">Add Menu</button>
      </div>
    </form>
  );
};

export default NewMenuForm;
